import { ChangePassword } from '../../../../interfaces/user.interface';
import { Validation } from '../../../../interfaces/common';
import { VALIDATION_FIELD_MAPPING, APP_ERROR_MESSAGES, Regex } from "../../../../utils/appConstant"

export const validateChangePasswordForm = (
  { currentPassword, newPassword, confirmPassword }: ChangePassword, 
  fieldToValidate?: string
) => {
  const validations: Validation = { validate: true, fields: [] }

  if(!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.currentPassword) {
    if(!currentPassword.trim()) { validations.validate = false; validations.fields.push({ field: VALIDATION_FIELD_MAPPING.currentPassword, message: APP_ERROR_MESSAGES.users.changePassword.blankCurrentPassword }) }
  }

  if(!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.newPassword) {
    if(!newPassword) { validations.validate = false; validations.fields.push({ field: VALIDATION_FIELD_MAPPING.newPassword, message: APP_ERROR_MESSAGES.users.changePassword.blankNewPassword }) }
    else if (newPassword && !Regex.password.test(newPassword)) { validations.validate = false; validations.fields.push({ message: APP_ERROR_MESSAGES.users.changePassword.passwordFormat, field: VALIDATION_FIELD_MAPPING.newPassword }); }
  }

  if(!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.confirmPassword) {
    if(!confirmPassword) { validations.validate = false; validations.fields.push({ field: VALIDATION_FIELD_MAPPING.confirmPassword, message: APP_ERROR_MESSAGES.users.changePassword.blankConfirmPassword }) }
    else if (newPassword !== confirmPassword) { validations.validate = false; validations.fields.push({ field: VALIDATION_FIELD_MAPPING.confirmPassword, message: APP_ERROR_MESSAGES.users.changePassword.passwordsDoNotMatch }) }
  }

  return validations
}